export default {
    en: {
        receipt: {
            item: "Item",
            quantity: 'Quantitiy',
            price: 'Price',
            total: 'Total',
            msg: 'Thank you for your purchase!'
        }
    },
    uz: {
        receipt: {
            item: "Mahsulot",
            quantity: 'Miqdori',
            price: 'Narxi',
            total: 'Jami',
            msg: "Xaridingiz uchun tashakur!"
        }
    },
    ru: {
        receipt: {
            item: "Продукт",
            quantity: 'Количество',
            price: 'Цена',
            total: 'Всего',
            msg: 'Спасибо за покупку!'
        }
    }

}